import moment from 'moment';

/**
 * Normalises any event.date value into the current JSONB shape
 * ({ type, startDate, endDate, … } or { type, days }).
 *
 * Handles two legacy formats that exist for older events whose DB column
 * was originally Sequelize.DATE before being migrated to JSONB:
 *   1. A plain ISO-8601 string  →  "2024-06-15T00:00:00.000Z"
 *   2. A bare date string        →  "2024-06-15"
 *
 * Returns the original object unchanged when it already has the modern shape,
 * or null when the value is completely unusable.
 */
const normalizeEventDate = (date) => {
  if (!date) return null;

  // Already in the expected shape
  if (typeof date === 'object' && date.type) return date;

  // Legacy: plain timestamp string stored before the column became JSONB
  if (typeof date === 'string') {
    const m = moment(date);
    if (!m.isValid()) return null;

    return {
      type: 'fixed',
      startDate: m.format('YYYY-MM-DD'),
      endDate: m.format('YYYY-MM-DD'),
      openHours: null,
      closeHours: null,
    };
  }

  return null;
};

export default normalizeEventDate;
